// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_routes_unauthorized_unauthorized_module_ts":"535f416350e05392","src_app_routes_nao-encontrado_nao-encontrado_module_ts":"e41af2978ce71b21"}[chunkId] + ".js";
};